import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.css';
import './App.css';
import './components/Common/ToolBarSearch.scss';
import React from 'react';
import { ReduxRouter } from '@lagunovsky/redux-react-router';
import { registerLicense } from '@syncfusion/ej2-base';
import { createBrowserHistory } from 'history';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ajax } from 'rxjs/ajax';
import { map } from 'rxjs/operators';
import App from 'App';
import configureStore from './store/configureStore';
import { configurationService } from './subjects/ConfigurationService';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(history, initialState);

const rootElement = document.getElementById('root');

ajax('api/Config/B2C')
    .pipe(map((response) => response.response))
    .subscribe((config) => {
        configurationService.set(config);
        registerLicense(config.syncfusionLicenseKey);

        ReactDOM.render(
            <Provider store={store}>
                <ReduxRouter history={history} store={store}>
                    <GoogleReCaptchaProvider reCaptchaKey={config.googleSiteKey}>
                        {/*<AppInsightsErrorBoundary onError={() => <h1>something went wrong</h1>} appInsights={reactPlugin}>*/}
                            <App history={history} />
                        {/*</AppInsightsErrorBoundary>*/}
                    </GoogleReCaptchaProvider>
                </ReduxRouter>
            </Provider>
            ,
            rootElement
        );
    });
